module.exports = __webpack_public_path__ + "img/learningTree.a49489fc.svg";